<template>
	<div class="group-maintain-container" style="padding: 20px;">
		<!-- 筛选条件：年级 + 班级 + 学科 -->
		<div class="search-bar" style="margin-bottom: 20px; display: flex; gap: 10px;">
			<el-select v-model="searchForm.gradeId" placeholder="请选择年级" style="width: 150px"
				@change="handleGradeChange">
				<el-option v-for="item in gradeList.filter(v=>v.id!=0&&v.isRole==true)" :key="item.gradeId"
					:label="item.gradeName" :value="item.gradeId" />
			</el-select>

			<el-select v-model="searchForm.classId" placeholder="请选择班级" style="width: 150px"
				:disabled="!searchForm.gradeId" @change="getSubjectList">
				<el-option v-for="item in classList.filter(v=>v.id!=0&&v.isRole==true)" :key="item.id"
					:label="item.classAlias" :value="item.id" />
			</el-select>

			<el-select v-model="searchForm.subjectId" placeholder="请选择学科" style="width: 150px"
				:disabled="!searchForm.classId" @change="getGroupList">
				<el-option v-for="item in subjectList.filter(v=>v.value!=0&&v.isRole==true)" :key="item.value"
					:label="item.label" :value="item.value" />
			</el-select>

			<el-button type="primary" @click="addGroup" :disabled="searchForm.subjectId==''">新增小组</el-button>
		</div>

		<!-- 小组列表 -->
		<div class="group-list" v-if="searchForm.subjectId">
			<el-card v-for="group in groupList" :key="group.id" shadow="hover"
				style="width: 400px; margin-bottom: 15px;">
				<div slot="header" class="clearfix">
					<span>{{ group.groupName }}</span>
					<div style="float: right;">
						<el-button type="text" @click="editGroup(group)">编辑</el-button>
						<el-button type="text" danger @click="deleteGroup(group.id)" style="color: red;">删除</el-button>
					</div>
				</div>

				<!-- 小组内学生 -->
				<div>
					<el-button size="mini" type="success" icon="el-icon-plus" @click="openStudentSelect(group)">
						选择学生
					</el-button>
					<el-tag v-for="stu in group.studentList" :key="stu.studentId" type="success" closable
						@close="removeStudentFromGroup(group.id, stu.studentId)" style="margin: 5px">
						{{ stu.name }}
					</el-tag>
					<div v-if="!group.studentList.length" style="color:#ccc;margin-top:10px">
						暂无学生，请点击选择学生
					</div>
				</div>
			</el-card>
		</div>

		<div v-else style="color:#999">
			请先选择 年级 → 班级 → 学科，查看对应小组
		</div>

		<!-- 小组新增/编辑弹窗 -->
		<el-dialog title="小组信息" :visible.sync="groupDialogVisible" width="400px">
			<el-form :model="groupForm" label-width="80px">
				<el-form-item label="小组名称">
					<el-input v-model="groupForm.groupName" placeholder="请输入小组名称" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="groupDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="saveGroup">确认保存</el-button>
			</div>
		</el-dialog>

		<!-- 学生选择弹窗（不可重复） -->
		<el-dialog title="选择学生（不可重复加入其他小组）" :visible.sync="studentDialogVisible" width="600px">
			<el-table :data="studentSelectList" row-key="studentId" ref="studentTable" border style="width: 100%;"
				:row-class-name="rowDisabled" @select="handleSelect" @select-all="handleSelectAll">
				<el-table-column type="selection" :selectable="row => !row.inGroup" width="55" />
				<el-table-column label="学号" prop="studentNo" />
				<el-table-column label="姓名" prop="name" />
			</el-table>

			<div slot="footer" class="dialog-footer">
				<el-button @click="studentDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="saveStudentToGroup">确认选择</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {getUserClassList} from "@/js/userRole.js"
	export default {
		name: "GroupMaintain",
		data() {
			return {
				searchForm: {
					gradeId: "",
					classId: "",
					subjectId: "",
				},
				gradeList: [],
				classList: [],
				subjectList: [],
				groupList: [],
				groupDialogVisible: false,
				groupForm: {
					id: "",
					groupName: "",
					classId: "",
					subjectId: "",
				},
				studentDialogVisible: false,
				currentGroup: null,
				studentSelectList: [],
				allUsedStudentIds: [],
				list: [],
				login:null,
			};
		},
		created() {
			this.forList()
		},
		methods: {
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},
			handleSelect() {

			},
			handleSelectAll(){
				
			},
			async forList() {
				this.loginOpen('班级数据加载中...')
				try{
					this.gradeList=await getUserClassList(this.API) || []
					
				}catch(err){
					this.gradeList=[]
				}finally{
					this.noLogin()
				}
			},
			handleGradeChange(val) {
				this.searchForm.classId = ""
				this.searchForm.subjectId = ""
				this.groupList = []
				const grade = this.gradeList.find(v => v.gradeId == val)
				this.classList = grade ? grade.classList : []
			},

			getSubjectList() {
				console.log('this.searchForm',this.searchForm)
				this.searchForm.subjectId = ""
				this.groupList = []
				const cls = this.classList.find(v => v.id == this.searchForm.classId)
				console.log('cls',cls)
				this.subjectList = cls ? cls.subjectList : []
			},

			async getGroupList() {
				if (!this.searchForm.subjectId) {
					this.groupList = []
					return
				}
				this.studentSelectList = await this.getStudengList()
				try {
					const res = await this.API.get(this.API.school.getGroupList, {
						classId: this.searchForm.classId,
						subjectId: this.searchForm.subjectId,
					})
					this.groupList = (res.data || []).map(g => ({
						...g,
						studentList: g.studentList || []
					}))
				} catch (e) {
					this.groupList = []
				}
			},

			async getStudengList() {
				try {
					const res = await this.API.get(this.API.school.getGroupStudentList, {
						classId: this.searchForm.classId,
						subjectId: this.searchForm.subjectId,
					})
					return res.data || []
				} catch {
					return []
				}
			},

			addGroup() {
				if (!this.searchForm.subjectId) {
					this.$message.warning("请先选择学科")
					return
				}
				this.groupForm = {
					id: "",
					groupName: "",
					classId: this.searchForm.classId,
					subjectId: this.searchForm.subjectId,
				}
				this.groupDialogVisible = true
			},

			editGroup(row) {
				this.groupForm = {
					...row
				}
				this.groupDialogVisible = true
			},

			saveGroup() {
				if (!this.groupForm.groupName) {
					this.$message.warning("请输入小组名称")
					return
				}
				if (this.groupForm.id) {
					this.API.post(this.API.school.postGroupUpdate, this.groupForm).then(res => {
						this.$message.success(res.data.msg)
						this.getGroupList()
					})
				} else {
					this.API.post(this.API.school.postGroupCreate, this.groupForm).then(res => {

						this.$message.success(res.data.msg)
						this.getGroupList()
					})
				}
				this.groupDialogVisible = false
			},

			deleteGroup(id) {
				this.$confirm("确定删除该小组吗？", "提示", {
						type: "warning"
					})
					.then(() => {
						this.API.post(this.API.school.deletedGroupId + id).then(res => {
							this.getGroupList()
							this.$message.success("删除成功")
						})


					})
			},

			openStudentSelect(group) {
				this.currentGroup = group
				this.studentDialogVisible = true

				this.allUsedStudentIds = []
				this.groupList.forEach(g => {
					(g.studentList || []).forEach(s => {
						this.allUsedStudentIds.push(s.studentId)
					})
				})

				this.getStudengList().then(data => {
					this.studentSelectList = data
				})
			},

			rowDisabled({
				row
			}) {
				return this.allUsedStudentIds.includes(row.studentId) ? "disabled-row" : ""
			},

			// ======================
			// 关键：保存学生并调用修改接口
			// ======================
			saveStudentToGroup() {
				const selected = this.$refs.studentTable.selection
				if (!selected || selected.length === 0) {
					this.$message.warning("请选择学生")
					return
				}

				// 🔥 新增：把【当前小组已有的学生】也一起带上！！！
				const oldStudentIds = this.currentGroup.studentList.map(s => s.studentId) || []

				// 新勾选的学生
				const newStudentIds = selected.map(s => s.studentId)

				// 合并：旧学生 + 新勾选学生（去重）
				const allStudentIds = [...new Set([...oldStudentIds, ...newStudentIds])]

				const params = {
					id: this.currentGroup.id,
					classId: this.currentGroup.classId,
					subjectId: this.currentGroup.subjectId,
					groupName: this.currentGroup.groupName,
					status: 1,
					studentIds: allStudentIds // 🔥 传合并后的全部学生
				}

				this.API.post(this.API.school.postGroupUpdate, params).then(res => {
					this.$message.success("学生保存成功")
					this.getGroupList()
					this.studentDialogVisible = false
				}).catch(() => {
					this.$message.error("保存失败")
				})
			},

			removeStudentFromGroup(groupId, studentId) {
				const group = this.groupList.find(x => x.id === groupId)
				if (!group) return

				// 移除后重新提交后端
				const newStudentIds = group.studentList
					.map(s => s.studentId)
					.filter(id => id !== studentId)

				const params = {
					id: group.id,
					classId: group.classId,
					subjectId: group.subjectId,
					groupName: group.groupName,
					status: 1,
					studentIds: newStudentIds
				}

				this.API.post(this.API.school.postGroupUpdate, params).then((res) => {
					this.$message.success(res.data.msg)
					this.getGroupList()
				})
			},
		},
	}
</script>

<style>
	/* 禁用已被占用的学生行 */
	.disabled-row {
		background: #f5f5f5 !important;
		color: #ccc !important;
		cursor: not-allowed !important;
	}
</style>